import {useEffect, useMemo, useState} from 'external/react'
import {createStandardsDataController} from '../domain/data.cjs'

export default function useStandardsData({load, filters, language}) {
  const [datasets, setDatasets] = useState({})
  const controller = useMemo(() => createStandardsDataController(load, (entity, state, snapshot) => setDatasets(snapshot)), [load])
  useEffect(() => () => controller.dispose(), [controller])
  useEffect(() => {
    controller.refresh(filters, language)
  }, [controller, language, filters.standard_set, filters.subject, filters.grade, filters.standard, filters.pattern])
  const retry = entity => controller.retry(entity, filters, language)
  return {datasets, retry}
}
